import {
  type OnUploadError,
  type Upload,
  type UploadErrorStateActions,
  type UploadErrorType,
  type UUID,
  ValidationStatus
} from '@pixum/types';
import { ImageFileValidationErrors } from '@pixum/types/lib/image-file-validation-service/image-file-validation-errors';
import type { ImageStateUpdater } from '../../../../types/expressDesigner';

const SERVER_STATUS_TO_ERROR_TYPE: Partial<Record<ValidationStatus, string>> = {
  [ValidationStatus.TOO_LARGE]: ImageFileValidationErrors.TOO_BIG
};

function resolveUploadErrorType(
  errorType: string | undefined,
  serverStatus: ValidationStatus | undefined
): string | undefined {
  const isServerFailure = errorType === ImageFileValidationErrors.SERVER_VALIDATION_FAILED;

  if (isServerFailure && serverStatus) {
    return SERVER_STATUS_TO_ERROR_TYPE[serverStatus] ?? errorType;
  }

  return errorType;
}

export function onUploadError(
  updater: ImageStateUpdater,
  uploadErrorStateActions: UploadErrorStateActions,
  getValidationStatus?: (uuid: string) => ValidationStatus | undefined
): OnUploadError {
  return (uploadId: UUID, uploadErrorType?: UploadErrorType, errorType?: string, file?: File, upload?: Upload) => {
    const serverStatus = getValidationStatus?.(uploadId as unknown as string);
    const resolvedErrorType = resolveUploadErrorType(errorType, serverStatus);

    uploadErrorStateActions.addUploadError({
      uuid: uploadId,
      upload,
      file,
      uploadErrorType,
      errorType: resolvedErrorType
    });

    updater.updateImage({
      uuid: uploadId,
      errorType: resolvedErrorType,
      uploadErrorType
    });
  };
}
